import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { createColumnBuilder } from "../../../components/table/columnBuilder";
import type { SponsoredAdsAudienceRow } from "../../../zodios/apiDefinitions/api/sponsoredAdsAudience";
import type { SponsoredAdsAudienceGrouping } from "./sponsoredAdsAudienceGroupings";

const columnHelper = createColumnBuilder<SponsoredAdsAudienceRow>();

export function useSponsoredAdsAudienceReportColumns(grouping: SponsoredAdsAudienceGrouping, metricIds: string[]) {
  const { t } = useTranslation(["perf_reports"]);
  return useMemo(
    () => [
      columnHelper.accessor("segment_name", {
        id: "segment_name",
        header: t(($) => $.perf_reports["Audience Segment"]),
        minSize: 200,
        size: 280,
        maxSize: 500,
        enableHiding: false,
        enableColumnFilter: false,
      }),
      ...(grouping === "segment_name,campaign_id" ?
        [
          columnHelper.accessor("campaign_name", {
            id: "campaign_name",
            header: t(($) => $.perf_reports["Campaign"]),
            minSize: 180,
            size: 240,
            maxSize: 500,
            enableColumnFilter: false,
          }),
        ]
      : []),
      ...metricIds.map((metricId) => columnHelper.metric(metricId)),
    ],
    [grouping, metricIds, t],
  );
}
